import { ShieldCheck, XCircle, BadgeDollarSign, PhoneCall } from "lucide-react";

const SIGNALS = [
  { icon: ShieldCheck, text: "Secure payments via Stripe" },
  { icon: XCircle, text: "No contracts — cancel anytime" },
  { icon: BadgeDollarSign, text: "Transparent pricing — website included, from $50/mo" },
  { icon: PhoneCall, text: "A real walkthrough call every month" },
];

export const TrustBar = () => (
  <div className="border-y border-white/10 bg-[#0B162B]/60 py-8" data-testid="trust-bar">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
        {SIGNALS.map((s) => (
          <span
            key={s.text}
            data-testid={`trust-signal-${s.text.split(" ")[0].toLowerCase()}`}
            className="inline-flex items-center gap-2.5 text-sm text-slate-300"
          >
            <s.icon className="h-4 w-4 text-white" />
            {s.text}
          </span>
        ))}
      </div>
    </div>
  </div>
);
